module.exports = __webpack_public_path__ + "img/2.62fcd8dc.png";